import { extractDigits } from '@/utils/string-formatting.js';

const storeName = 'comparehub_loanscanada';

const setCookie = (value) => {
    let name = storeName;
    let expirationDays = 30;

    let d = new Date();
    d.setTime(d.getTime() + (expirationDays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const setLocal = (value) => {
    let name = storeName;
    localStorage[name] = value;
}

const setSession = (value) => {
    let name = storeName;
    sessionStorage.setItem(name, value);
}

const getSafeApplicationData = (app) => {

    let removeTheseKeysFromAppObject = [
        'urlParameters',
        'password',
        'password_confirmation'
    ];

    let saveableData = {};
    Object.entries(app).forEach(entry => {
        if(!removeTheseKeysFromAppObject.includes(entry[0])) {
            saveableData[entry[0]] = entry[1];
        }
    });
    return JSON.stringify(saveableData);
}

const setLocalStorage = (app) => {
    let appData = getSafeApplicationData(app);
    // setCookie(appData);
    setLocal(appData);
    setSession(appData);
}

const getLocalStorage = (item = storeName) => {
    const raw = localStorage.getItem(item);
    return raw ? JSON.parse(raw) : null;
}

const getUrlParameters = () => {
    const entries = new URLSearchParams(window.location.search).entries();

    let appParameters = [
        'first_name',
        'last_name',
        'email',
        'affiliate_id',
        'product_name',
        'flinks_demo',
        'flinks_skip',
        // 'sms_skip',
        // refresh app - this helps to hide the message 'Continue with your application' when is a prepop lead
        'ra',
        'token',
        'dev_step',
        'dev_phase'
    ];

    let trackingParameters = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'cmi_click_id',
        'click_id',
        // => google click ids
        'gclid',
        // 'gbraid',
        // 'wbraid',
        // google click ids <==
        'fbclid',
        'ttclid',
        // ==> Snapchat Click IDs
        'ScCid',
        'sccid',
        // Snapchat Click IDs <==
        'msclkid',
        // affiliate
        'affiliate_id',
        'affiliate_sub1',
        'affiliate_sub2',
        'affiliate_sub3',
        'affiliate_sub4',
        'affiliate_sub5',
        'aff_utm_source',
        'aff_utm_medium',
        'aff_utm_campaign',
        'aff_utm_content',
        'aff_utm_term',
    ];

    let prepopFields = [
        'car_request_type',
        'car_request_monthly_budget',
        'new_asset_name',
        'requested_amount',
        'postal_code',
        'car_value',
        'cc_debt_amount',
        // from pre-pop
        // 'product_purpose', 'requested_amount', 'first_name', 'last_name', 'email', 'dob', 'city',
        // 'state', 'postal_code', 'cell_phone', 'work_phone', 'address', 'own_home', 'address_length_months',
        // 'rent_mortgage_payment', 'property_value', 'property_mortgage', 'income_type', 'employer', 'job_title',
        // 'monthly_income', 'employed_months', 'direct_deposit', 'pay_frequency', 'pay_date1',
        // 'in_dmp', 'in_bankruptcy', 'in_consumer_proposal', 'cc_debt_amount', 'unsecured_debt_amount',
        // 'lang', 'canadian_status', 'aff_utm_source', 'aff_utm_medium', "aff_utm_campaign", 'aff_utm_content', 'aff_utm_term',
        // 'affiliate_sub1', 'affiliate_sub2', 'affiliate_sub3', 'affiliate_sub4', 'affiliate_sub5'
    ];

    let forceOnlyDigits = [
        'requested_amount',
        // prepop
        // personal
        'cell_phone',
        'address_length_months',
        'rent_mortgage_payment',
        'property_value',
        'property_mortgage',
        // work
        'monthly_income',
        'employed_months',
        'work_phone',
        // debt
        'cc_debt_amount',
        'unsecured_debt_amount',
        // car
        'car_value',
        'car_request_monthly_budget',
    ];

    let mapFieldsFromCmi = {
        'cell_phone': 'phone_number',
        'work_phone': 'phone_number_work',
        'click_id': 'cmi_click_id',
    };

    const safeUrlParameters = [...appParameters,...trackingParameters, ...prepopFields];

    var urlParameters = {};
    for(const entry of entries) {
        var key = entry[0];
        var value = entry[1];

        if(safeUrlParameters.includes(key)) {
            // affiliate_id must be a clean numeric string. If the upstream link is
            // malformed (e.g. "?" used instead of "&" collapsing params into this
            // value), drop it — do NOT digit-strip it, as that produces wrong IDs.
            if (key === 'affiliate_id' && !/^\d+$/.test(value)) {
                continue;
            }
            urlParameters[mapFieldsFromCmi[key] ?? key] = forceOnlyDigits.includes(key) ? extractDigits(value) : value;
        }
    }

    // if gclid is not set lets try with the 2 other possible names
    // let googleClickValue = urlParameters['gclid'] || urlParameters['gbraid'] || urlParameters['wbraid'];
    // if (googleClickValue) {
    //     urlParameters['gclid'] = googleClickValue;
    // }
    // remove the other 2 google click ids
    // ['gbraid', 'wbraid'].forEach(key => delete urlParameters[key]);

    // when utm_source = 'snap' or 'snapchat'
    // we map ScCid or sccid to ttclid to be able to track snapchat clicks properly without needing to add extra logic elsewhere
    const utmSource = urlParameters['utm_source']?.toLowerCase();
    if (utmSource && ['snap','snapchat'].includes(utmSource)) {
        let snapClickId = urlParameters['ScCid'] || urlParameters['sccid'] || null;
        if (snapClickId) {
            urlParameters['ttclid'] = snapClickId;
        }
        // remove the other 2 snapchat click ids
        delete urlParameters['ScCid'];
        delete urlParameters['sccid'];
    }

    return urlParameters;
}

export { setLocalStorage, getLocalStorage, getUrlParameters }
